import {
  ScormRuntimeData,
  CoreEntry,
  IScormDataBuilder,
  CoreExit,
  CoreLessonStatus,
} from 'scorm/types'
import { ScormRunData } from 'modules/activityDetails/ElearningDetails/types'

export default class ElearningScormDataBuilder implements IScormDataBuilder {
  private CoreChildren: string = `student_id,student_name,lesson_location,credit,
    lesson_status,entry,score,total_time,lesson_mode,exit,session_time`
  private Credit: string = 'credit'
  private ScoreChildren: string = 'raw'
  private LessonMode: string = 'normal'
  private StudentDataChildren: string = 'mastery_score'
  private Version: string = '3.4'

  constructor(private scormData: ScormRunData, private masteryScore: number) {}

  public build(): ScormRuntimeData {
    const scormData: ScormRuntimeData = {
      CoreChildren: this.CoreChildren,
      Credit: this.Credit,
      ScoreChildren: this.ScoreChildren,
      LessonMode: this.LessonMode,
      StudentDataChildren: this.StudentDataChildren,
      Version: this.Version,
      StudentId: this.scormData.studentId,
      StudentName: this.scormData.studentName,
      LessonLocation: this.scormData.lessonLocation,
      LessonStatus: CoreLessonStatus[this.scormData.lessonStatus],
      ScormLocation: this.scormData.scormLocation,
      Entry: CoreEntry[this.scormData.entry],
      Exit: CoreExit[this.scormData.exit],
      LaunchData: this.scormData.launchData,
      MasteryScore: this.masteryScore.toString(),
      ScoreRaw: this.scormData.scoreRaw?.toString(),
      SessionTime: this.scormData.sessionTime,
      SuspendData: this.scormData.suspendData,
      TotalTime: this.scormData.totalTime,
    }
    return scormData
  }
}
